<template lang="pug">
#RecalcularPDF
  b-button(
    variant="action"
    @click="recalcularPDF"
    :disabled="disabled || loading"
  )
    | Recalcular cotización
    b-spinner.ml-2(v-if="loading" small)
</template>
<script>
import { mapActions } from 'vuex'

export default {
  name: 'RecalcularPDF',
  data() {
    return {
      loading: false,
    }
  },
  props: {
    dataOv: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    ...mapActions('OVStore', ['recalcularPDFCotizacion']),
    async recalcularPDF() {
      this.loading = true
      try {
        await this.recalcularPDFCotizacion({ id_oportunidad_venta: this.dataOv?.id })
        this.$bvToast.toast('PDF de cotización recalculado exitosamente', {
          variant: 'success',
          title: 'Éxito',
          autoHideDelay: 5000,
        })
      } catch (error) {
        const mensaje = error.response?.data?.mensaje || 'Error al recalcular el PDF de cotización'
        this.$bvToast.toast(mensaje, {
          variant: 'danger',
          title: 'Error',
          autoHideDelay: 5000,
        })
      } finally {
        this.loading = false
        // No emitir reloadAll, el websocket se encargará de actualizar los datos
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@import url('../Styles/Index.scss');

#RecalcularPDF {
  width: 100%;
  text-align: center;
  
  ::v-deep .btn {
    width: 100%;
    justify-content: center;
    text-align: center;
  }
}
</style>
